import { useSetAtom } from "jotai";
import { useCallback } from "react";

import {
  confirmedBookingModalTypeAtom,
  ConfirmedBookingModalType,
  isConfirmedBookingModalOpenAtom,
} from "../atoms/stores";

export const useOpenConfirmedBookingModalAfterCompletedBooking = () => {
  const setConfirmedBookingModalOpen = useSetAtom(
    isConfirmedBookingModalOpenAtom
  );
  const setConfirmedBookingModalType = useSetAtom(
    confirmedBookingModalTypeAtom
  );

  return useCallback(
    (type: ConfirmedBookingModalType = "default") => {
      setConfirmedBookingModalType(type);
      setConfirmedBookingModalOpen(true);
    },
    [setConfirmedBookingModalOpen, setConfirmedBookingModalType]
  );
};
